import PropTypes from "prop-types";
import { TablePagination } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

/**
 * Paginación única de las tablas de la app (MUI TablePagination con estilo y
 * textos comunes). `page` es base 0. Los callbacks reciben valores, no eventos:
 * onPageChange(page) y onRowsPerPageChange(rowsPerPage).
 */
export function DataTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  sx,
}) {
  const theme = useTheme();

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={(_event, newPage) => onPageChange?.(newPage)}
      onRowsPerPageChange={(event) =>
        onRowsPerPageChange?.(parseInt(event.target.value, 10))
      }
      rowsPerPageOptions={onRowsPerPageChange ? rowsPerPageOptions : []}
      labelRowsPerPage="Filas por página:"
      labelDisplayedRows={({ from, to, count: total }) =>
        `${from}-${to} de ${total !== -1 ? total : `más de ${to}`}`
      }
      sx={{
        borderTop: `1px solid ${theme.palette.divider}`,
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        flexShrink: 0,
        "& .MuiTablePagination-toolbar": {
          px: { xs: 1, md: 2 },
          minHeight: "52px",
          flexWrap: { xs: "wrap", md: "nowrap" },
          gap: { xs: 1, md: 0 },
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
          fontSize: { xs: "0.75rem", md: "0.8125rem" },
          color: theme.palette.text.secondary,
          whiteSpace: "nowrap",
        },
        "& .MuiTablePagination-select": {
          fontSize: { xs: "0.75rem", md: "0.8125rem" },
        },
        ...sx,
      }}
    />
  );
}

DataTablePagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  sx: PropTypes.object,
};

export default DataTablePagination;
